(() => {
'use strict';
const $ = id => document.getElementById('gh-'+id);
const L = window.OTTAR;
const LOGO_EL=document.querySelector(".gh-ottar .card-logo");
let LOGO_URI="";   // må vere data: - eksterne URL-ar blir blokkerte i SVG-render
const logoReady=(async()=>{
 try{
  if(!LOGO_EL||!LOGO_EL.src)return;
  const b=await fetch(LOGO_EL.src,{mode:"cors"}).then(r=>r.blob());
  LOGO_URI=await new Promise(res=>{const fr=new FileReader();fr.onload=()=>res(fr.result);fr.onerror=()=>res("");fr.readAsDataURL(b)});
 }catch(e){LOGO_URI=""}
})();

// Dialekt-tegnnamn (UI) -> zodiacBanter-nøkkel i biblioteket.
const SIGN_KEY={
 "Vatnkarn":"vannmannen","Feskan":"fiskene","Væreiarn":"vaeren","Tyrn":"tyren",
 "Tvellingan":"tvillingene","Kræpsn":"krepsen","Løva":"loeven","Jomfrua":"jomfruen",
 "Vækta":"vekten","Skorpion":"skorpionen","Skjøttarn":"skytten","Steinbiten":"steinbukken"
};
// ---------------------------------------------------------------------------
// SEASON 3 – POOL-ROUTING
// Poolane er delte i typar. Innanfor ei gruppe blir poolen vekta etter tal par,
// slik at kvart par har lik sjanse og små poolar ikkje gjentek seg.
// ---------------------------------------------------------------------------
const GROUPS={
 core:    ["ronny","marta","johannes","faren","bamse"],
 miljo:   ["kaia","havet","vaeret","batmotor","livet","personal","gulls","skatteetaten","soring"],
 scener:  ["observations","kaiaStories","kaffe","stikk"],
 fortelling:["gamleSjarken","stormen97","forsteKjarlighet","mysterier","nakneFolelser"]
};
// Justerbare sannsynligheiter.
const CFG={
 hovudCore:0.55,     // hovudavsnitt: core (resten miljø)
 ekstraAvsnitt:0.50, // sjanse for eitt ekstra avsnitt
 ekstraFortelling:0.45, // ekstra avsnitt: fortelling (resten småscener)
 kontekst:0.40,      // sesong/tid når det passar
 special:0.08,       // specials erstattar ekstra-avsnittet
 sjeldne:0.03,       // sjeldne-banner
 mytisk:0.005        // mytiske – tek over banneret
};
const pairs=k=>Array.isArray(L[k])?Math.floor(L[k].length/2):0;
// Vekta trekk av pool innanfor ei gruppe (eller fleire); hoppar over brukte/tomme poolar.
function pickPool(group,r,used){
 const ks=[].concat(...[].concat(group).map(g=>GROUPS[g])).filter(k=>!used.has(k)&&pairs(k)>0);
 const tot=ks.reduce((s,k)=>s+pairs(k),0);
 if(!tot)return null;
 let x=r()*tot;
 for(const k of ks){x-=pairs(k);if(x<0)return k}
 return ks[ks.length-1];
}


// Sesong- og tidspoolar: berre aktuelle når dei faktisk passar.
// Ottar snakkar ikkje om mørketid i juni.
function paaske(aar){ // computus
 const a=aar%19,b=Math.floor(aar/100),c=aar%100,d=Math.floor(b/4),e=b%4;
 const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30;
 const i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
 const md=h+l-7*m+114;
 return new Date(aar,Math.floor(md/31)-1,(md%31)+1);
}
function kontekstPoolar(){
 const d=new Date(), m=d.getMonth()+1, t=d.getHours(), ut=[];
 if(m===12||m<=2) ut.push("winter");
 if(m>=3&&m<=5)   ut.push("spring");
 if(m>=6&&m<=8)   ut.push("summer");
 if(m>=9&&m<=11)  ut.push("autumn");
 if(m>=11||m===1) ut.push("morketid");
 if(m>=5&&m<=7)   ut.push("midnattssol");
 if(m>=1&&m<=4)   ut.push("skrei");
 if(m===12&&d.getDate()>=1) ut.push("christmas");
 const p=paaske(d.getFullYear()), diff=Math.abs(d-p)/86400000;
 if(diff<=10) ut.push("easter");
 if(t>=4&&t<10)  ut.push("morning");
 if(t>=22||t<4)  ut.push("night");
 return ut.filter(k=>Array.isArray(L[k])&&L[k].length>1);
}

let current=null;
let pngBlob=null;   // ferdig PNG for deling/nedlasting
let pngUrl=null;

// Trygg: manglande/tom pool gir tom streng i staden for feil (Season 3 har ikkje alle poolar).
function choose(a,r){return (Array.isArray(a)&&a.length)?a[Math.floor(r()*a.length)]:""}
function int(a,b,r){return Math.floor(r()*(b-a+1))+a}
// Trekk eit sammenhengande par (oppsett + punchline) frå ein pool.
function couplet(pool,r){
 if(!pool||!pool.length)return[];
 if(pool.length===1)return[pool[0]];
 const i=int(0,Math.floor((pool.length-2)/2),r)*2;
 return[pool[i],pool[i+1]];
}
// Sl\u00e5 eit par saman til eitt avsnitt (pent handtert "..."-par).
// Har begge linjene innleiingsfrase, blir berre den f\u00f8rste brukt \u2013 to
// tidsangivingar etter kvarandre les som maskin, ikkje som Ottar.
function joinCouplet(pool,r){
 const c=couplet(pool,r);
 if(c.length<2)return c[0]||"";
 let a=c[0],b=c[1];
 if(/(\.\.\.|\u2026)\s*$/.test(a)&&/^\s*(\.\.\.|\u2026)/.test(b))b=b.replace(/^\s*(\.\.\.|\u2026)\s*/,"");
 return a+" "+b;
}

function build(){
 const sign=$("sign").value;
 const zkey=SIGN_KEY[sign];
 const r=Math.random;
 const used=new Set();
 const body=[];
 const trace=[];   // kva poolar dommen bygde på (for QA/debug)

 // 1) PREFIKS + OPENING (openings er enkeltlinjer)
 const pfx=(L.prefixes&&L.prefixes.length)?choose(L.prefixes,r):"";
 const opening=choose(L.openings,r)||"";
 body.push(pfx?pfx+" "+opening:opening); trace.push("openings");

 // 2) STJERNETEIKN
 const zb=L.zodiacBanter&&L.zodiacBanter[zkey];
 if(zb&&zb.length){body.push(joinCouplet(zb,r)); trace.push("zodiac:"+zkey)}

 // 3) HOVUDAVSNITT: core eller miljø
 const g1=r()<CFG.hovudCore?"core":"miljo";
 const p1=pickPool(g1,r,used)||pickPool(g1==="core"?"miljo":"core",r,used);
 if(p1){used.add(p1);body.push(joinCouplet(L[p1],r));trace.push(p1)}

 // 4) EKSTRA AVSNITT: special, fortelling eller småscene
 if(r()<CFG.ekstraAvsnitt){
  if(pairs("specials")>0&&r()<CFG.special){
   body.push(joinCouplet(L.specials,r)); trace.push("specials");
  }else{
   const g2=r()<CFG.ekstraFortelling?"fortelling":"scener";
   // Tom gruppe (t.d. fortelling utan S3-tekstar) -> fall tilbake til den andre
   // Tom gruppe (t.d. fortelling utan S3-tekstar): trekk vekta frå alle body-grupper,
   // så trykket ikkje hopar seg opp på dei minste scene-poolane.
   const p2=pickPool(g2,r,used)||pickPool(["scener","miljo","core","fortelling"],r,used);
   if(p2){used.add(p2);body.push(joinCouplet(L[p2],r));trace.push(p2)}
  }
 }

 // 5) SESONG / TID
 const kp=kontekstPoolar();
 if(kp.length&&r()<CFG.kontekst){const k=choose(kp,r);body.push(joinCouplet(L[k],r));trace.push(k)}

 // 6) SPESIAL: mytisk > sjeldne
 let special="",specialTitle="";
 if(Array.isArray(L.mytiske)&&L.mytiske.length&&r()<CFG.mytisk){
  const m=choose(L.mytiske,r); specialTitle=m.title; special=m.text; trace.push("mytiske");
 }else if(Array.isArray(L.sjeldne)&&L.sjeldne.length&&r()<CFG.sjeldne){
  special=choose(L.sjeldne,r); trace.push("sjeldne");
 }


 return{
  sign,
  opening:body[0]||"",
  paragraphs:body.slice(1).filter(Boolean),
  wisdom:choose(L.wisdom,r),
  ending:choose(L.endings,r),
  special,specialTitle,trace,
  metrics:[["Motvind",int(4,63,r)+"%"],["Kaffebehov",int(4,12,r)+" koppa"],["Haill",int(5,79,r)+"%"]]
 }
}
function render(){
 current=build();
 $("badge").textContent=current.sign.toUpperCase();
 const ps=[current.opening,...current.paragraphs,current.ending].filter(Boolean);
 $("body").innerHTML=ps.map(x=>"<p>"+escapeHtml(x)+"</p>").join("");
 $("wisdom").textContent=current.wisdom?"«"+current.wisdom+"»":"";
 // Som i PNG-en: tre boksar på rad.
 $("metrics").style.gridTemplateColumns="repeat(3,minmax(0,1fr))";
 $("metrics").innerHTML=current.metrics.map((x,i)=>'<div class="metric" style="text-align:center"><small>'+x[0].toUpperCase()+'</small><strong style="font-size:18px;white-space:nowrap">'+escapeHtml(x[1])+'</strong></div>').join("");
 $("special").hidden=!current.special;
 $("special").textContent=current.specialTitle?current.specialTitle+" – "+current.special:current.special;
 $("status").textContent="";
 buildPng();   // lag bildet i bakgrunnen så deling kan sende det
}
function escapeHtml(s){return s.replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]))}
function text(){return[current.sign,current.special?(current.specialTitle?current.specialTitle+" – ":"")+current.special:"",current.opening,...current.paragraphs,current.ending,(current.wisdom?"Siste ord: «"+current.wisdom+"»":""),"www.godthaill.com/ottar"].filter(Boolean).join("\n\n")}
// Invitasjon til ein venn - ingen dom, berre eit puff.
const INVITE=[
 "Æ spurte Gammel-Ottar om dagen min. No e det din tur.",
 "Gammel-Ottar sitt på kaia og seier ka han meine. Prøv sjøl.",
 "Du burde høre ka Gammel-Ottar har å sei om dagen din.",
 "Gammel-Ottar lyg aldri. Spørsmåle e om du tåle svaret.",
 "Ta ein tur på kaia. Gammel-Ottar har nokre ord til dæ."
];
function inviteText(){ return choose(INVITE,Math.random)+"\n\nwww.godthaill.com/ottar" }

async function copy(){
 const t=inviteText();
 try{
  if(navigator.share){ await navigator.share({text:t}); return; }
  await navigator.clipboard.writeText(t);
  $("status").textContent="Invitasjon kopiert \u2013 lim inn og send.";
 }catch(e){
  try{ await navigator.clipboard.writeText(t); $("status").textContent="Invitasjon kopiert \u2013 lim inn og send."; }
  catch(e2){ $("status").textContent="Kunne ikkje kopiere automatisk."; }
 }
}

// Brekk tekst i linjer som får plass innenfor maxWidth. Måler mot faktisk font
// via canvas measureText, så brytinga stemmer med det SVG-en faktisk rendrer.
function wrapText(str,maxWidth,font){
 const ctx=wrapText._c||(wrapText._c=document.createElement("canvas").getContext("2d"));
 ctx.font=font;
 const words=String(str).split(/\s+/).filter(Boolean);
 const lines=[];let line="";
 for(const w of words){
  const test=line?line+" "+w:w;
  if(line&&ctx.measureText(test).width>maxWidth){lines.push(line);line=w}
  else line=test;
 }
 if(line)lines.push(line);
 return lines.length?lines:[""];
}
// Mål breidda på ein tekst med gitt font.
wrapText._m=function(str,font){
 const ctx=wrapText._c||(wrapText._c=document.createElement("canvas").getContext("2d"));
 ctx.font=font; return ctx.measureText(String(str)).width;
};

function svgString(){
 const safe=x=>escapeHtml(x);
 const FF='Arial, "Helvetica Neue", Helvetica, sans-serif';
 const paras=[current.opening,...current.paragraphs,current.ending].filter(Boolean);

 // SPESIAL-BANNER (sjeldne/mytiske) mellom badge og tekst
 let banner="",bannerH=0;
 if(current.special){
  const st=(current.specialTitle?current.specialTitle+" – ":"")+current.special;
  const sl=wrapText(st,820,`800 30px ${FF}`).slice(0,3), slh=38;
  bannerH=sl.length*slh+28;
  banner=`<rect x="110" y="548" width="860" height="${bannerH}" rx="16" fill="#ebc65b"/>`;
  sl.forEach((ln,i)=>{banner+=`<text x="540" y="${548+14+30+i*slh}" text-anchor="middle" font-size="30" font-weight="800" fill="#142833">${safe(ln)}</text>`});
 }

 // BODY: brekk hver setning, krymp font hvis nødvendig, sentrer blokka vertikalt
 const bodyTop=bannerH?548+bannerH+22:575,bodyBottom=1265,bodyMax=900,gap=24;
 let fs=44,lh=45,wrapped=[],blockH=0;
 for(fs=44;fs>=20;fs-=2){
  lh=Math.round(fs*1.32);
  wrapped=paras.map(p=>wrapText(p,bodyMax,`700 ${fs}px ${FF}`));
  blockH=wrapped.reduce((h,ls)=>h+ls.length*lh,0)+gap*(wrapped.length-1);
  if(blockH<=bodyBottom-bodyTop)break;
 }
 let y=Math.round(bodyTop+((bodyBottom-bodyTop)-blockH)/2+fs*0.8);
 let body="";
 for(const para of wrapped){
  for(const ln of para){body+=`<text x="540" y="${y}" text-anchor="middle" font-size="${fs}" font-weight="700" fill="white">${safe(ln)}</text>`;y+=lh}
  y+=gap;
 }

 // VISDOM-BOKS: brekk både sitat og avslutning, la boksen vokse med innholdet
 const boxTop=1390,boxX=95,boxW=890,inner=800;
 let wfs=34,wLines=wrapText("«"+current.wisdom+"»",inner,`italic 700 34px ${FF}`);
 while(wLines.length>3&&wfs>26){wfs-=2;wLines=wrapText("«"+current.wisdom+"»",inner,`italic 700 ${wfs}px ${FF}`)}
 const wLH=Math.round(wfs*1.32),firstLine=110,padB=38;
 const boxH=firstLine+(wLines.length-1)*wLH+padB;
 let wy=boxTop+firstLine;
 let wisdom=`<text x="540" y="${boxTop+54}" text-anchor="middle" font-size="26" font-weight="900" letter-spacing="3" fill="#ebc65b">SISTE ORD</text>`;
 for(const ln of wLines){wisdom+=`<text x="540" y="${wy}" text-anchor="middle" font-size="${wfs}" font-style="italic" font-weight="700" fill="white">${safe(ln)}</text>`;wy+=wLH}

 // METRICS: tre boksar på éi rad, rett over Siste ord
 let metrics="";
 {const x0=95,W=890,gap=10,y0=1290,h1=84;
  const sw=Math.floor((W-2*gap)/3);
  current.metrics.slice(0,3).forEach((m,i)=>{
   const x=x0+i*(sw+gap);
   let vfs=30; while(vfs>18 && wrapText._m(m[1],`800 ${vfs}px ${FF}`)>sw-40) vfs-=1;
   metrics+=`<rect x="${x}" y="${y0}" width="${sw}" height="${h1}" rx="16" fill="#0004" stroke="#ffffff35"/>`
          + `<text x="${x+sw/2}" y="${y0+34}" text-anchor="middle" font-size="22" font-weight="800" fill="#ffffffbf">${safe(m[0].toUpperCase())}</text>`
          + `<text x="${x+sw/2}" y="${y0+70}" text-anchor="middle" font-size="${vfs}" font-weight="800" fill="white">${safe(m[1])}</text>`;
  });
 }

 const badgeTxt=current.sign.toUpperCase();
 const badge=safe(badgeTxt);
 const bW=Math.round(wrapText(badgeTxt,4000,`900 28px ${FF}`)[0].length*0)+Math.max(260,Math.round(badgeTxt.length*20+120));
 const bX=Math.round((1080-bW)/2);

 return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1080" height="1920" font-family='${FF}'><defs><linearGradient id="g" x2="0" y2="1"><stop stop-color="#183746"/><stop offset="1" stop-color="#081820"/></linearGradient></defs><rect width="1080" height="1920" fill="url(#g)"/>${LOGO_URI?`<image xlink:href="${LOGO_URI}" href="${LOGO_URI}" x="370" y="252" width="340" height="146"/>`:""}<text x="540" y="424" text-anchor="middle" font-size="26" font-weight="900" letter-spacing="6" fill="#ffffff" fill-opacity="0.72">ORAKLET PÅ KAIA</text><rect x="${bX}" y="462" width="${bW}" height="68" rx="34" fill="#ebc65b"/><text x="540" y="507" text-anchor="middle" font-size="28" font-weight="900" fill="#142833">${badge}</text>${banner}${body}<rect x="${boxX}" y="${boxTop}" width="${boxW}" height="${boxH}" rx="24" fill="#0005" stroke="#ffffff40"/>${wisdom}${metrics}<text x="540" y="1660" text-anchor="middle" font-size="28" font-weight="800" fill="white">www.godthaill.com/ottar</text></svg>`;
}
// Lag PNG i bakgrunnen og hald den klar for deling/nedlasting.
async function buildPng(){
 try{
  await logoReady;   // vent til logoen er koda som data-URI
  if(pngUrl){URL.revokeObjectURL(pngUrl);pngUrl=null}
  pngBlob=null;
  const svg=svgString();
  const url=URL.createObjectURL(new Blob([svg],{type:"image/svg+xml;charset=utf-8"}));
  const img=new Image();
  img.onload=()=>{
   try{
    const canvas=document.createElement("canvas");
    canvas.width=1080;canvas.height=1920;
    canvas.getContext("2d").drawImage(img,0,0,1080,1920);
    URL.revokeObjectURL(url);
    canvas.toBlob(b=>{ if(b){pngBlob=b;pngUrl=URL.createObjectURL(b)} },"image/png");
   }catch(e){URL.revokeObjectURL(url)}
  };
  img.onerror=()=>URL.revokeObjectURL(url);
  img.src=url;
 }catch(e){}
}
function pngFile(){ return pngBlob? new File([pngBlob],"gammel-ottars-dom.png",{type:"image/png"}) : null }

// Del: send sjølve bildet når det går, elles tekst.
async function share(){
 const f=pngFile();
 try{
  if(f && navigator.canShare && navigator.canShare({files:[f]})){
   await navigator.share({files:[f]});
   return;
  }
  if(navigator.share){ await navigator.share({title:"Gammel-Ottars dom",text:text()}); return; }
  await copy();
 }catch(e){}
}

// Last ned: anker på desktop, visning med "hald inne for å lagre" på mobil.
function showImage(url){
 let box=document.getElementById("gh-imgout");
 if(!box){
  box=document.createElement("div");
  box.id="gh-imgout";
  box.style.cssText="margin-top:14px";
  const card=document.getElementById("gh-card");
  card.parentNode.insertBefore(box,card.nextSibling);
 }
 box.innerHTML='<p style="font-weight:800;margin:0 0 8px">Hald inne på bildet og vel «Lagre bilde».</p><img src="'+url+'" style="width:100%;border-radius:18px;display:block">';
 box.scrollIntoView({behavior:"smooth",block:"start"});
}
function download(){
 if(!pngBlob){ $("status").textContent="Lage bilde… prøv igjen om eit sekund."; buildPng(); return; }
 const touch = window.matchMedia && window.matchMedia("(pointer:coarse)").matches;
 const a=document.createElement("a");
 const supportsDl = "download" in a;
 if(touch || !supportsDl){ showImage(pngUrl); $("status").textContent=""; return; }
 a.href=pngUrl; a.download="gammel-ottars-dom.png"; a.click();
 $("status").textContent="Bilde lasta ned.";
}
$("copy").addEventListener("click",copy);$("share").addEventListener("click",share);$("download").addEventListener("click",download);

// ---------------------------------------------------------------------------
// FØRSTE BESØK: Ottar står allereie på kaia og ventar.
// Visast berre første gong (localStorage). Test på nytt med ?intro=1 i URL-en.
// ---------------------------------------------------------------------------
const INTRO_KEY="gh-ottar-intro-seen";
const INTRO=[
 "Du kom altså hit.",
 "Jaja.",
 "Æ e Ottar. Har stått her på kaia lengre enn det som strengt tatt e nødvendig, og sett folk gjør de samme feilene på stadig nye måta.",
 "Havet fortell det meste. Resten får æ gjett mæ til.",
 "Så tenk på det du lure på.",
 "Når du e klar, skal vi se ka som driv i land."
];
const INTRO_BTN="Æ e klar";
let introOpen=false;
function introSeen(){
 try{ if(/[?&]intro=1\b/.test(location.search))return false; return localStorage.getItem(INTRO_KEY)==="1"; }catch(e){ return false; }
}
function markIntroSeen(){ try{ localStorage.setItem(INTRO_KEY,"1"); }catch(e){} }
function hideForIntro(on){
 const card=$("card"), wis=card&&card.querySelector?card.querySelector(".wisdom"):null, act=document.querySelector(".gh-ottar .actions");
 [wis,act,$("generate"),$("metrics"),document.getElementById("gh-shop")].forEach(el=>{ if(el) el.style.display=on?"none":""; });
}
function showIntro(){
 introOpen=true;
 hideForIntro(true);
 $("special").hidden=true;
 $("body").innerHTML=INTRO.map(x=>"<p>"+escapeHtml(x)+"</p>").join("")
  +'<p style="margin-top:18px;text-align:center"><button type="button" id="gh-intro-go" class="primary" style="min-width:210px;font:inherit;font-weight:850;border:0;border-radius:11px;padding:13px;background:#ebc65b;color:#142833;cursor:pointer">'+escapeHtml(INTRO_BTN)+'</button></p>';
 document.getElementById("gh-intro-go").addEventListener("click",closeIntro);
}
function closeIntro(){
 if(!introOpen) return;
 introOpen=false;
 markIntroSeen();
 hideForIntro(false);
 render();
}
// ---------------------------------------------------------------------------
// BESTSELGERE under Del / Tips / Last ned
// Hentar frå butikken sin eigen /collections/bestselgere/products.json (same origin).
// Feilar det, blir seksjonen berre ikkje vist.
// ---------------------------------------------------------------------------
const SHOP_COLLECTION="bestselgere", SHOP_LIMIT=8;
function kr(v){const n=Math.round(parseFloat(v)||0);return n.toLocaleString("nb-NO")+" kr"}
function imgW(url,w){if(!url)return"";return url+(url.includes("?")?"&":"?")+"width="+w}
async function loadShop(){
 try{
  const app=document.querySelector(".gh-ottar .app"); if(!app||document.getElementById("gh-shop"))return;
  const res=await fetch("/collections/"+SHOP_COLLECTION+"/products.json?limit="+SHOP_LIMIT,{credentials:"same-origin"});
  if(!res.ok)return;
  const data=await res.json(); const ps=(data&&data.products||[]).filter(p=>p.variants&&p.variants.length);
  if(!ps.length)return;
  const box=document.createElement("section"); box.id="gh-shop";
  box.style.cssText="margin-top:26px;text-align:center";
  const cards=ps.map(p=>{
   const price=Math.min(...p.variants.map(v=>parseFloat(v.price)||Infinity));
   const cmp=Math.max(0,...p.variants.map(v=>parseFloat(v.compare_at_price)||0));
   const img=p.images&&p.images[0]?imgW(p.images[0].src,400):"";
   return '<a href="/products/'+encodeURIComponent(p.handle)+'" style="display:block;text-decoration:none;color:#142833;background:#fff;border:1px solid #c8d4da;border-radius:14px;overflow:hidden;text-align:center">'
    +(img?'<img src="'+escapeHtml(img)+'" alt="'+escapeHtml(p.title)+'" loading="lazy" style="display:block;width:100%;aspect-ratio:1/1;object-fit:cover;background:#f4f4f4">':'')
    +'<div style="padding:9px 8px 11px"><div style="font-size:14px;font-weight:800;line-height:1.25">'+escapeHtml(p.title)+'</div>'
    +'<div style="font-size:14px;font-weight:700;margin-top:4px">'+(cmp>price?'<span style="text-decoration:line-through;opacity:.55;font-weight:600;margin-right:6px">'+kr(cmp)+'</span>':'')+kr(price)+'</div></div></a>';
  }).join("");
  box.innerHTML='<h2 style="font-size:22px;margin:0 0 12px">Bestselgere</h2>'
   +'<div style="display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px">'+cards+'</div>'
   +'<a href="/collections/'+SHOP_COLLECTION+'" style="display:inline-block;margin-top:14px;padding:13px 22px;border-radius:11px;background:#397493;color:#fff;font-weight:850;text-decoration:none">Se alle bestselgere</a>';
  const st=$("status"); (st&&st.parentNode===app)?app.insertBefore(box,st.nextSibling):app.appendChild(box);
  if(introOpen) box.style.display="none";
 }catch(e){}
}

// Knappane lukkar introen om brukaren hoppar rett på dei.
$("generate").addEventListener("click",()=>{ if(introOpen) closeIntro(); else render(); });
$("sign").addEventListener("change",()=>{ if(!introOpen) render(); });
if(!introSeen()) showIntro();
loadShop();
// Etter introen: startteksten står til brukaren trykker "Spør Ottar".
})();